import { render, staticRenderFns } from "./BaseIconSVG.vue?vue&type=template&id=78f48d31&scoped=true&"
import script from "./BaseIconSVG.vue?vue&type=script&lang=js&"
export * from "./BaseIconSVG.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconSVG.vue?vue&type=style&index=0&id=78f48d31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f48d31",
  null
  
)

export default component.exports